import groq from 'groq';
import { SanityKeyed, TextboxCard } from '../../schemaTypes';

export type TextboxCardBlock = SanityKeyed<TextboxCard>;

export const textboxCardProjection = groq`
  ...
`;
